import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect, Route, Switch, useLocation, useParams } from 'react-router-dom';

import { hideHeaderSignIn } from '../../lib/aui-header';
import { checkIsAuthenticated } from '../../lib/helpers';
import { isEsbFormOneIncomplete } from '../../lib/shared-signup';
import { getMarketingDataFromUrl } from '../../lib/side-effects';
import { getEsbConfigMap, initializeEsbFlow } from '../../lib/side-effects/esb';
import { selectState } from '../../selectors';
import { getEsbConfig } from '../../selectors/esb';
import { setEsbPartner } from '../../store/esb';
import { setActiveFlow } from '../../store/system';
import LoadingRocket from '../loading-rocket';
import CreateLogin from './create-login';
import EsbStartTrialForms from './forms';
import SignIn from './sign-in';

const EsbLandingPage = () => {
  const dispatch = useDispatch();
  const { search } = useLocation();
  const {
    account: { isLoggedIn },
    esb: { esbConfigMap, esbPartner, esbPath },
    sharedSignup,
  } = useSelector(selectState);

  const esbConfig = useSelector(getEsbConfig);
  const isAuthenticated = checkIsAuthenticated();

  const { partnerId } = useParams<{ partnerId?: string }>();

  useEffect(() => {
    if (partnerId) {
      dispatch(setEsbPartner(partnerId));
      dispatch(getEsbConfigMap(partnerId));
    }
  }, [partnerId]);

  useEffect(() => {
    dispatch(setActiveFlow('esb-trial'));
    dispatch(getMarketingDataFromUrl());
    return hideHeaderSignIn();
  }, []);

  // biome-ignore lint/correctness/useExhaustiveDependencies: leaving as is
  useEffect(() => {
    dispatch(initializeEsbFlow());
  }, [esbConfig?.id, isAuthenticated, isLoggedIn]);

  if (!esbConfigMap || !esbPartner || !esbConfigMap[esbPartner]) return null;

  // TODO - handle the scenario where add on is enabled *AND* payment is required
  if (isAuthenticated && esbConfig?.isAddOnEnabled) {
    return <LoadingRocket />;
  }

  return (
    <Switch>
      <Route exact path={`/${esbPath}/:partnerId/create-login`}>
        {isEsbFormOneIncomplete(sharedSignup) ? (
          <Redirect to={{ pathname: `/${esbPath}/${partnerId || ''}`, search }} />
        ) : (
          <CreateLogin />
        )}
      </Route>

      <Route exact path={`/${esbPath}/:partnerId/sign-in`} component={SignIn} />

      <Route component={EsbStartTrialForms} />
    </Switch>
  );
};

export default EsbLandingPage;
